// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"ProjectList_mainSection__a7bXe","projectItem":"ProjectList_projectItem__eFtiL"};